import ImxDigital from 'assets/icons/imx_digital.svg'
import StudioX from 'assets/icons/studio_x.svg'

export const PartnersData = [
  {
    title: 'Studio X',
    description: 'The studio of the future.',
    img: StudioX,
    link: '',
  },
  {
    title: 'IMX Digital',
    description: 'A SharePoint site of digital products, tools and analytics.',
    img: ImxDigital,
    link: 'https://groups.coca-cola.com/sites/Digital-IMX',
  },
]
